import React, {Component} from 'react';
import {Card, DatePicker, Divider, Icon, Table} from 'antd';
import {Link} from 'react-router-dom';
import LinkButton from '../../components/LinkButton';
import {reqGetPaymentReport} from '../../api';
import {CSVLink} from 'react-csv';

const {RangePicker} = DatePicker;


export default class PaymentReport extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      payments: [], //payment
      date_from: '',
      date_to: '',
    };

    //initialize table columns
    this.initColumns();
  }

  componentDidMount() {
    //this.setState({loading: true});
    //this.ajaxGetPaymentReport();
  }

  onChange = (dates, moment) => {
    this.setState({loading: true});
    reqGetPaymentReport(moment)
      .then(response => {
        const payments = response.data;
        this.setState({payments,date_from:moment[0],date_to:moment[1]});
        //disable loading
        this.setState({loading: false});
      })
      .catch(error => {
        console.log(error.response);
      });
  }

  //initial table columns
  initColumns = () => {
    this.columns = [
      {
        title: 'Order#',
        key: 'order_id',
        render: (order) =>
          <span>
            <Link to={'/orders/edit/' + order.order_id}>
            <LinkButton>{order.order_number}</LinkButton>
            </Link>
          </span>
      },
      {
        title: 'Customer',
        dataIndex: 'customer',
      },
      {
        title: 'Sales',
        dataIndex: 'sales',
      },
      {
        title: 'Job Description',
        dataIndex: 'job_description',
      },
      {
        title: 'Payment Date',
        dataIndex: 'payment_date',
      },
      {
        title: 'Payment Type',
        dataIndex: 'payment_type',
      },
      {
        title: 'Currency',
        dataIndex: 'currency',
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
      },
      {
        title: 'Added Date',
        dataIndex: 'added_date',
      },
      {
        title: 'Added By',
        dataIndex: 'added_by',
      },
      {
        title: 'Action',
        render: (order) =>
          <span>
            <Link to={'/orders/view/' + order.order_id}>
            <LinkButton onClick={() => this.props.history.push('/orders/view/' + order.order_id)}><Icon
              type="eye"/></LinkButton>
            </Link>
            <Divider type="vertical"/>
            <Link to={'/orders/edit/' + order.order_id}>
            <LinkButton onClick={() => this.props.history.push('/orders/edit/' + order.order_id)}><Icon
              type="edit"/></LinkButton>
            </Link>
          </span>
      },
    ];
  };

  render() {
    const {loading, payments, date_from, date_to} = this.state;
    const title = (
      <div>
        <h4>Payment Date</h4>
        <span><RangePicker onChange={this.onChange}/></span>
      </div>
    );

    return (
      <div className="customer">
        <Card title={title}>
          <div style={{paddingBottom: '25px'}}>
            <CSVLink
              data={payments}
              filename={"Payment-report(" + date_from + "~" + date_to + ").csv"}
            >
              Download Payment Report
            </CSVLink>
          </div>
          <Table
            loading={loading}
            rowKey="id"
            columns={this.columns}
            dataSource={payments}
            size="small"
            pagination={false}
          />
        </Card>
      </div>
    );
  }
}